import type { SVGAttributes } from 'react';
import type { ChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

const Svg = chakra('svg');

type Props = Omit<SVGAttributes<SVGElement>, keyof ChakraProps> & ChakraProps;

const ProfileBanner = (props: Props) => (
  <Svg
    width='100%'
    viewBox='0 0 1500 200'
    fill='none'
    overflow='visible'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M172.445 85.445-106-193h1620L1298.6 22.401c-96.98 96.981-254.22 96.981-351.199 0-94.662-94.662-248.14-94.662-342.802 0l-63.044 63.044c-101.927 101.927-267.183 101.927-369.11 0Z'
      fill='#F3F9FA'
    />
    <circle cx={883.5} cy={86.5} r={14.5} fill='#50B2C2' />
    <circle cx={382} cy={-19} r={205.25} stroke='#BDDEE1' strokeWidth={1.5} />
    <circle cx={1373.5} cy={-63.5} r={170.75} stroke='#E9BC9B' strokeWidth={1.5} />
    <circle cx={149} cy={69} r={23} fill='#E58F38' />
  </Svg>
);

export default ProfileBanner;
